import { Coupon, Item } from '@/@types/cart'
import { currentPrice } from '@/helpers/current-price'

import { computed, ComputedRef, InjectionKey, ref, Ref } from 'vue'

export interface CartTotals {
  totalQuantity: ComputedRef<number>
  subtotal: ComputedRef<number>
  standardCouponApplies: ComputedRef<boolean>
  total: Ref<number>
  installmentTotals: Ref<number>
  discount: Ref<number>
}

export const cartTotalsKeys = Symbol('cartTotals') as InjectionKey<CartTotals>

export function useCartTotals(cartItems: ComputedRef<Item[]>, coupon?: ComputedRef<Coupon | undefined>) {
  const totalQuantity: ComputedRef<number> = computed(() => {
    return cartItems.value.reduce((acc, item) => acc + item.quantity, 0)
  })


  const subtotal: ComputedRef<number> = computed(() => {
    return cartItems.value.reduce((acc, item) => acc + item.quantity * currentPrice(item.ticket), 0)
  })

  const standardCouponApplies = computed(() => totalQuantity.value >= 5)

  function applyCoupon(value: number): number {

    if (!coupon?.value) return value

    if (coupon.value.category === 'currency') {
      return value - coupon.value.value_cents / 100
    } else {
      return value * (1 - coupon.value.percentage_value / 100)
    }
  }

  const installmentTotals = ref(0)
  const discount = ref(0)

  const total: ComputedRef<number> = computed(() => {
    const baseTotal = subtotal.value

    let finalTotal = baseTotal

    if (standardCouponApplies.value) {
      discount.value = finalTotal * 0.10
      finalTotal -= discount.value
    }

    finalTotal = applyCoupon(finalTotal)
    return finalTotal < 0 ? 0 : finalTotal
  })


  return {
    totalQuantity,
    subtotal,
    standardCouponApplies,
    total,
    installmentTotals,
    discount
  }
}
